import { motion } from "framer-motion";
import { waLink } from "@/data/content";
import { WaIcon } from "./Contact";

export const WhatsAppFab = () => (
  <motion.a
    data-testid="whatsapp-fab"
    aria-label="Fale pelo WhatsApp"
    href={waLink("Olá! Vim pelo site da FMACIEL e gostaria de mais informações.")}
    target="_blank"
    rel="noreferrer"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 15 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#0B132B] border border-[#25D366]/50 shadow-[0_10px_40px_rgba(37,211,102,0.35)]"
  >
    <span className="absolute inset-0 rounded-full border border-[#25D366] animate-ping opacity-30" />
    <WaIcon size={28} />
  </motion.a>
);
